import { InputTable } from '@/components/custom/arito';
import ActionBar from './ActionBar';
import type { BulkDeleteCellParams } from './useTable';

interface DetailTabProps {
  rows: { uuid?: string | null }[];
  selectedRowUuid?: string | null;
  onRowClick?: (params: any) => void;
  handleDeleteRow: () => void;
  onCellClick?: (params: BulkDeleteCellParams) => void;
  checkboxSelection?: boolean;
  selectedRowIds?: string[];
  onRowSelectionChange?: (selectedIds: string[]) => void;
  columns?: any[];
}

export const DetailTab: React.FC<DetailTabProps> = ({
  rows,
  selectedRowUuid,
  onRowClick,
  handleDeleteRow,
  checkboxSelection = false,
  selectedRowIds = [],
  onRowSelectionChange,
  columns
}) => {
  return (
    <InputTable
      rows={rows}
      onRowClick={!checkboxSelection ? onRowClick : undefined}
      selectedRowId={!checkboxSelection ? selectedRowUuid || undefined : undefined}
      columns={columns || []}
      getRowId={row => row?.uuid || ''}
      actionButtons={<ActionBar handleDeleteRow={handleDeleteRow} handlePin={() => {}} />}
      checkboxSelection={checkboxSelection}
      selectedRowIds={selectedRowIds}
      onRowSelectionChange={onRowSelectionChange}
      className='h-[70vh]'
    />
  );
};

export default DetailTab;
